import { Injectable } from '@angular/core';
import { EMPTY_STRING, Numbers, TIMERS } from '@app/constants';
import { ToastTypeEnum } from '@app/enums/toast-type.enum';
import { ToastInterface } from '@app/interface/toast.interface';
import { BehaviorSubject } from 'rxjs';

enum ToastServicePropertiesEnum {
  button = 'button',
}

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private readonly type: string = ToastTypeEnum.Danger;
  private readonly title: string = EMPTY_STRING;
  private readonly description: string = EMPTY_STRING;
  private readonly closeBtnIsActive: boolean = true;
  private readonly button:
    | ToastInterface[ToastServicePropertiesEnum.button]
    | null = null;
  private readonly timer: number = TIMERS.SixThousandMS;
  public show = new BehaviorSubject<ToastInterface | undefined>(undefined);

  open(props: Partial<ToastInterface> = { }) {
    const {
      type = this.type,
      title = this.title,
      description = this.description,
      closeBtnIsActive = this.closeBtnIsActive,
      button = this.button,
      timer = this.timer,
    } = props;

    this.show.next({
      type,
      title,
      description,
      closeBtnIsActive,
      button,
      timer,
    });

    if (timer > Numbers.zero) {
      setTimeout(() => (this.close()), timer);
    }
  }

  close() {
    this.show.next(undefined);
  }
}
